<loading-component>
  <div slot="end" class="loading__title">{{ 'REDSYS_REDIRECT.TITLE' | translate }}</div>
  <div slot="end" class="loading__description">{{ 'REDSYS_REDIRECT.DESCRIPTION' | translate }}</div>
</loading-component>